import { NgModule } from '@angular/core';
import { ApolloModule, APOLLO_OPTIONS } from 'apollo-angular';
import { ApolloClientOptions, InMemoryCache, ApolloLink, split, DefaultOptions } from '@apollo/client/core';
import { HttpLink } from 'apollo-angular/http';
import { OAuthService } from 'angular-oauth2-oidc';
import { setContext } from '@apollo/client/link/context';
import { apiUrl } from './config';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { HttpClientModule } from '@angular/common/http';

/**
 * GraphQL-Endpunkt der sitos-x-api, abgeleitet aus der members-api-URL (apiUrl).
 *
 * Exportiert, damit die Ableitung nur an dieser einen Stelle steht: Der ImageReader
 * braucht die Origin, um zu entscheiden, ob der Access-Token mitgeschickt werden darf
 * (Logos werden von diesem Host ausgeliefert).
 */
export const sitosApiUrl = apiUrl.replace('members-api', 'sitos-x-api');

export function createApollo(this: void, httpLink: HttpLink, oauth: OAuthService): ApolloClientOptions<any> {
  const basic = setContext((operation, context) => ({
    headers: {
      Accept: 'charset=utf-8',
    },
  }));

  const auth = setContext(async (_, { headers }) => {
    // Grab token if there is one in storage or hasn't expired
    let token = oauth.getAccessToken();
    const refreshToken = oauth.getRefreshToken(); // Get refresh token

    if (!token) {
      if (refreshToken) {
        await oauth.refreshToken();
      }
      token = oauth.getAccessToken();
    }
    // Return the headers as usual
    return {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
  });

  // KS, 20260622
  // in apiUrl steht der Link zur members-api
  const httpLinkMemberservice = httpLink.create({ uri: apiUrl });

  //const httpLinkSitos = httpLink.create({ uri: 'https://sitos-x-api-dev-lab-kschaab.stage.sitos-x.com/graphql/' });
  const httpLinkSitos = httpLink.create({ uri: sitosApiUrl });

  const linkMemberservice = ApolloLink.from([basic, auth, httpLinkMemberservice]);
  const linkSitos = ApolloLink.from([basic, auth, httpLinkSitos]);

  const defaultOptions: DefaultOptions = {
      watchQuery: {
          fetchPolicy: 'no-cache',
          errorPolicy: 'all',
      },
      query: {
          fetchPolicy: 'no-cache',
          errorPolicy: 'all',
      },
  };
  const link = split(
    ({ getContext }) => getContext().client === 'sitosxapi',
    linkSitos,
    linkMemberservice
  );
  return {
    link,
    cache: new InMemoryCache(),
    defaultOptions,
  };
}

@NgModule({
  imports: [ApolloModule, HttpClientModule],
  providers: [
    {
      provide: APOLLO_OPTIONS,
      useFactory: createApollo,
      deps: [HttpLink, OAuthService],
    },
    provideHttpClient(withInterceptorsFromDi()),
  ],
})
export class GraphQLModule {}
